import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LoginIframe extends Component {
    componentWillMount() {
        window.addEventListener('message', this.onMessage, false);
        document.addEventListener('touchstart', this.onMouseTouchOutside, false);
        this.disablePageZooming();
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.onMessage, false);
        document.removeEventListener('touchstart', this.onMouseTouchOutside, false);
        this.enablePageZooming();
        this.iframe.blur();
    }

    onMouseTouchOutside = ({ target }) => {
        if (target !== this.iframe) {
            this.iframe.blur();
        }
    }

    onMessage = ({ data: { event, data } }) => {
        if (event === 'login') {
            if (data.success) {
                this.props.onLoginSuccess();
            } else {
                this.props.onBackClick();
            }
        }
        if ((event === 'default') && data.success) {
            this.props.onBackClick();
        }
        if ((event === 'serverError') && !data.success) {
            this.props.onBackClick();
        }
    }

    onIframeSetRef = (node) => {
        this.iframe = node;
    }

    disablePageZooming() {
        const viewPortMetaTag = document.querySelector('meta[name="viewport"]');
        this.oldViewPortContent = viewPortMetaTag.getAttribute('content');
        const newViewPortContent = this.oldViewPortContent.toLowerCase()
            .split(',')
            .map(option => option.trim())
            .filter(option => !option.includes('user-scalable'))
            .concat('user-scalable=no')
            .join(', ');
        viewPortMetaTag.setAttribute('content', newViewPortContent);
    }

    enablePageZooming() {
        const viewPortMetaTag = document.querySelector('meta[name="viewport"]');
        viewPortMetaTag.setAttribute('content', this.oldViewPortContent);
    }

    render() {
        const { authUrl } = this.props;
        return (
            <div className="bs-loginIframe__wrapper">
                <iframe
                    ref={this.onIframeSetRef}
                    className="bs-iframeContainer"
                    src={authUrl}
                    title="login"
                />
            </div>
        );
    }
}

LoginIframe.defaultProps = {
    authUrl: '',
};

LoginIframe.propTypes = {
    authUrl: PropTypes.string.isRequired,
    onLoginSuccess: PropTypes.func.isRequired,
    onBackClick: PropTypes.func.isRequired,
};

export default LoginIframe;



// WEBPACK FOOTER //
// /src/js/common/loginPage/components/LoginIframe.jsx